export function Female(
  props: React.SVGAttributes<SVGSVGElement>
): React.ReactElement {
  return (
    <svg
      width="14"
      height="21"
      viewBox="0 0 14 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.9688 6.75049C13.9688 3.02393 10.9453 0.000488281 7.21875 0.000488281C3.49219 0.000488281 0.46875 3.02393 0.46875 6.75049C0.46875 10.2239 3.09375 13.088 6.46875 13.4583V16.5005H4.03125C3.72187 16.5005 3.46875 16.7536 3.46875 17.063V17.438C3.46875 17.7474 3.72187 18.0005 4.03125 18.0005H6.46875V20.438C6.46875 20.7474 6.72188 21.0005 7.03125 21.0005H7.40625C7.71562 21.0005 7.96875 20.7474 7.96875 20.438V18.0005H10.4062C10.7156 18.0005 10.9688 17.7474 10.9688 17.438V17.063C10.9688 16.7536 10.7156 16.5005 10.4062 16.5005H7.96875V13.4583C11.3438 13.088 13.9688 10.2239 13.9688 6.75049ZM1.96875 6.75049C1.96875 3.84893 4.3125 1.50049 7.21875 1.50049C10.1203 1.50049 12.4688 3.84424 12.4688 6.75049C12.4688 9.65205 10.125 12.0005 7.21875 12.0005C4.31719 12.0005 1.96875 9.65674 1.96875 6.75049Z"
        fill="black"
      />
    </svg>
  );
}
